import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { RESET_PASSWORD, UPDATE_PERSONNEL } from './types';

export const resetPassword = createTaskAction(RESET_PASSWORD);

export const updatePersonnel = createTaskAction(UPDATE_PERSONNEL);
